import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-navy-lighter border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
          
          <div className="text-center md:text-left flex flex-col items-center md:items-start">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/74bbba00a2df2b2cb399e3d568aceadd.png" 
              alt="AgentOnDemand Logo" 
              className="h-16 w-auto object-contain mb-4"
            />
            <span className="text-gray-400 text-sm tracking-wider uppercase">
              LIVE AGENTS. REAL RESULTS. ON DEMAND.
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm font-medium text-gray-300">
            <a href="#" className="hover:text-gold transition-colors">Home</a>
            <a href="#pricing" className="hover:text-gold transition-colors">Pricing</a>
            <a href="#" className="hover:text-gold transition-colors">FAQ</a>
            <a href="#booking" className="hover:text-gold transition-colors">Contact</a>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} AgentOnDemand. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;